/*!
 * Infinite Ajax Scroll v2.1.1
 * A jQuery plugin for infinite scrolling
 * http://infiniteajaxscroll.com
 *
 * Commercial use requires one-time purchase of a commercial license
 * http://infiniteajaxscroll.com/docs/license.html
 *
 * Non-commercial use is licensed under the MIT License
 *
 * Copyright (c) 2014 Webcreate (Jeroen Fiege)
 */
 
var IASCallbacks = function () {
    return this.list = [], this.fireStack = [], this.isFiring = !1, this.isDisabled = !1, this.fire = function (a) {
        var b = a[0],
            c = a[1],
            d = a[2];
        this.isFiring = !0;
//        try {
        for (var e = 0, f = this.list.length; f > e; e++)
            if (!1 === this.list[e].fn.apply(b, d)) {
                c.reject();
                break
            }
//        }catch(err){cyclone3.log('error:' + err)};
        this.isFiring = !1, c.resolve(), this.fireStack.length && this.fire(this.fireStack.shift())
    }, this.inList = function (a, b) {
        b = b || 0;
        for (var c = b, d = this.list.length; d > c; c++)
            if (this.list[c].fn === a || a.guid && this.list[c].fn.guid && a.guid === this.list[c].fn.guid) return c;
        return -1
    }, this
};

IASCallbacks.prototype = {
    add: function (a, b) {
        var c = {
            fn: a,
            priority: b
        };
        b = b || 0;
        for (var d = 0, e = this.list.length; e > d; d++)
            if (b > this.list[d].priority) return this.list.splice(d, 0, c), this;
        return this.list.push(c), this
    },
    remove: function (a) {
        for (var b = 0;
            (b = this.inList(a, b)) > -1;) this.list.splice(b, 1);
        return this
    },
    has: function (a) {
        return this.inList(a) > -1
    },
    fireWith: function (a, b) {
        var c = $.Deferred();
        return this.isDisabled ? c.reject() : (b = b || [], b = [a, c, b.slice ? b.slice() : b], this.isFiring ? this.fireStack.push(b) : this.fire(b), c)
    },
    disable: function () {
        this.isDisabled = !0
    },
    enable: function () {
        this.isDisabled = !1
    }
},
function (a) {
    "use strict";
    var b = -1,
        c = function (c, d) {
            return this.itemsContainerSelector = d.container, this.itemSelector = d.item, this.nextSelector = d.next, this.paginationSelector = d.pagination, this.$scrollContainer = c, this.$itemsContainer = a(this.itemsContainerSelector), this.$container = window === c.get(0) ? a(document) : c, this.defaultDelay = d.delay, this.negativeMargin = d.negativeMargin, this.nextUrl = null, this.isBound = !1, this.listeners = {
                next: new IASCallbacks,
                load: new IASCallbacks,
                loaded: new IASCallbacks,
                render: new IASCallbacks,
                rendered: new IASCallbacks,
                scroll: new IASCallbacks,
                noneLeft: new IASCallbacks,
                ready: new IASCallbacks
            }, this.extensions = [], this.extensions_ = [], this.scrollHandler = function () {
                var a = this.getCurrentScrollOffset(this.$scrollContainer),
                    c = this.getScrollThreshold();
                this.isBound && b != c && (this.fire("scroll", [a, c]), a >= c && this.next())
            }, this.getLastItem = function () {
//						cyclone3.log('ias.getLastItem()');
                return a(this.itemSelector, this.$itemsContainer.get(0)).last()
            }, this.getFirstItem = function () {
//						cyclone3.log('ias.getFirstItem()');
                return a(this.itemSelector, this.$itemsContainer.get(0)).first()
            }, this.getScrollThreshold = function (a) {
//					cyclone3.log('ias.getScrollThreshold()');
                var c;
                return a = a || this.negativeMargin, a = a >= 0 ? -1 * a : a, c = this.getLastItem(), 0 === c.length ? b : c.offset().top + c.height() + a
            }, this.getCurrentScrollOffset = function (a) {
//					cyclone3.log('ias.getCurrentScrollOffset()');
                var b = 0,
                    c = a.height();
                return b = window === a.get(0) ? a.scrollTop() : a.offset().top,
						(-1 != navigator.platform.indexOf("iPhone") || -1 != navigator.platform.indexOf("iPod")) && (c += 80),
						b + c
//            }, this.reset = function (b) {
//					try {
//						this.prevUrl = this.getPrevUrl()
//					}catch(e){};
//					this.nextUrl = this.getNextUrl();
//					this.restorePagination();
            }, this.getNextUrl = function (b) {
					cyclone3.log('ias.getNextUrl() searching = ' + a(this.nextSelector, b).last().attr("href"));
                return b || (b = this.$container), a(this.nextSelector, b).last().attr("href")
            }, this.load = function (b, c, d) {
						cyclone3.log('ias.load()');
                var e, f, g = this,
                    h = [],
                    i = +new Date;
                d = d || this.defaultDelay;
                var j = {
                    url: b
                };
                return g.fire("load", [j]), a.get(j.url, null, a.proxy(function (b) {
						e = a(this.itemsContainerSelector, b).eq(0),
							0 === e.length && (e = a(b).filter(this.itemsContainerSelector).eq(0)),
							e && e.find(this.itemSelector).each(function (){
//									cyclone3.log('h.push()');
//									cyclone3.log(h);
									h.push(this);
							}),
							g.fire("loaded", [b, h]),
							c && (f = +new Date - i, d > f ? setTimeout(function () {
//								cyclone3.log('call g=' + g);
								c.call(g, b, h)
							}, d - f) : c.call(g, b, h))
                }, g), "html")
            }, this.render = function (b, c) {
//					cyclone3.log('this.render()');
                var d = this,
                    e = this.getLastItem(),
                    f = 0,
                    g = this.fire("render", [b]);
                g.done(function () {
//							cyclone3.log('this.render().done()');
                    a(b).hide(), e.after(b), a(b).fadeIn(400, function () {
//							  cyclone3.log('this.render().done().item()');
                        ++f < b.length || (d.fire("rendered", [b]), c && c())
                    })
                })
            }, this.hidePagination = function () {
                this.paginationSelector && a(this.paginationSelector, this.$container).hide()
            }, this.restorePagination = function () {
                this.paginationSelector && a(this.paginationSelector, this.$container).show()
            }, this.throttle = function (b, c) {
                var d, e, f = 0;
                return d = function () {
                    function a() {
                        f = +new Date, b.apply(d, g)
                    }
                    var d = this,
                        g = arguments,
                        h = +new Date - f;
                    e ? clearTimeout(e) : a(), h > c ? a() : e = setTimeout(a, c)
                }, a.guid && (d.guid = b.guid = b.guid || a.guid++), d
            }, this.fire = function (a, b) {
                return this.listeners[a].fireWith(this, b)
            }, this
        };
    c.prototype.initialize = function () {
			cyclone3.log('ias.initialize()');
        var a = this.getCurrentScrollOffset(this.$scrollContainer),
            b = this.getScrollThreshold();
        this.hidePagination(), this.bind();
        for (var c = 0, d = this.extensions.length; d > c; c++){
				this.extensions[c].bind(this)
		  };
        return this.fire("ready"),
			this.nextUrl = this.getNextUrl(), a >= b && this.next(),
//			this.prevUrl = this.getPrevUrl() && this.prev(),
			this
    }, c.prototype.extension_initialize = function () { /* romanko napisal */
			cyclone3.log('ias.extension_initialize()');
        for (var c = 0, d = this.extensions.length; d > c; c++) this.extensions[c].bind(this);
			this
    }, c.prototype.reset = function () {
			cyclone3.log('ias.reset()');
			var a = this.getCurrentScrollOffset(this.$scrollContainer),
			b = this.getScrollThreshold();
			
//			this.nextUrl = this.getNextUrl();
			
			this.hidePagination(), this.bind();
//        for (var c = 0, d = this.extensions.length; d > c; c++) this.extensions[c].bind(this);
			return this.fire("ready"), this.nextUrl = this.getNextUrl(), a >= b && this.next(), this
    }, c.prototype.bind = function () {
//			cyclone3.log('ias.bind()');
        this.isBound || (this.$scrollContainer.on("scroll", a.proxy(this.throttle(this.scrollHandler, 150), this)), this.isBound = !0)
    }, c.prototype.unbind = function () {
			cyclone3.log('ias.unbind()');
//			try {
//				for (var c = 0, d = this.extensions.length; d > c; c++) this.extensions[c].unbind(this);
//			}catch(e){
//				cyclone3.log('ias.unbind() error:' + e);
//			}
		
        this.isBound && (this.$scrollContainer.off("scroll", this.scrollHandler), this.isBound = !1)
    }, c.prototype.destroy = function () {
//			cyclone3.log('ias.destroy()');
        this.unbind()
    }, c.prototype.on = function (b, c, d) {
//			cyclone3.log('ias.on()');
        if ("undefined" == typeof this.listeners[b]) throw new Error('There is no event called "' + b + '"');
        return d = d || 0, this.listeners[b].add(a.proxy(c, this), d), this
    }, c.prototype.one = function (a, b) {
//		 cyclone3.log('ias.one()');
        var c = this,
            d = function () {
                c.off(a, b), c.off(a, d)
            };
        return this.on(a, b), this.on(a, d), this
    }, c.prototype.off = function (a, b) {
//		 cyclone3.log('ias.off()');
        if ("undefined" == typeof this.listeners[a]) throw new Error('There is no event called "' + a + '"');
        return this.listeners[a].remove(b), this
    }, c.prototype.next = function () {
		cyclone3.log('ias.next()');
        var a = this.nextUrl,
            b = this;
        if (this.unbind(), !a) return this.fire("noneLeft", [this.getLastItem()]), this.listeners.noneLeft.disable(), b.bind(), !1;
        var c = this.fire("next", [a]);
        return c.done(function () {
            b.load(a, function (a, c) {
                b.render(c, function () {
                    b.nextUrl = b.getNextUrl(a), b.bind()
                })
            })
        }), c.fail(function () {
            b.bind()
        }), !0
    }, c.prototype.extension = function (a,b) {
        if ("undefined" == typeof a.bind) throw new Error('Extension doesn\'t have required method "bind"');
        return "undefined" != typeof a.initialize && a.initialize(this), this.extensions.push(a), this.extensions_[b]=a
    }, a.ias = function () {
//		 cyclone3.log('ias.ias()');
        var b = a(window);
//        cyclone3.log('b=' + b);
        return b.ias.apply(b, arguments)
    }, a.fn.ias = function (b) {
			cyclone3.log('ias.fn.ias()');
        var d = Array.prototype.slice.call(arguments),
            e = this;
        return this.each(function () {
            var f = a(this),
                g = f.data("ias"),
						 h = a.extend({}, a.fn.ias.defaults, f.data(), "object" == typeof b && b);
					if (
						g || (
							f.data("ias", g = new c(f, h))
							, a(document).ready(a.proxy(g.initialize, g))
						), "string" == typeof b) {
						 if ("function" != typeof g[b]) throw new Error('There is no method called "' + b + '"');
						 d.shift(), g[b].apply(g, d), "destroy" === b && f.data("ias", null)
            }
            e = f.data("ias")
        }), e
    }, a.fn.ias.defaults = {
        item: ".item",
        container: ".listing",
        next: ".next",
        pagination: !1,
        delay: 600,
        negativeMargin: 10
    }
}(jQuery);

var IASHistoryExtension = function (a) {
    return a = $.extend({}, this.defaults, a), this.ias = null, this.prevSelector = a.prev, this.prevUrl = null, this.listeners = {
        prev: new IASCallbacks
    }, this.onPageChange = function (a, b, c) {
        var d = {};
        /* muziker modification */
			c=c.replace(/node=\d+&?/,'');
			c=c.replace(/q=[^=&]+&?/,'');
			c=c.replace(/page_limit=\d+&?/,'');
			c=c.replace(/page_limit_more=\d+&?/,'');
			c=c.replace(/ias=true&?/,'');
			c=c.replace(/&&/,'&');
			c=c.replace(/&$/,'');
			c=c.replace(/\?&/,'?');
			c=c.replace(/^.*?\?/,'#');
			cyclone3.log('ias.pagechange() ' + c);
        window.history && window.history.replaceState && history.replaceState(d, document.title, c)
    }, this.onScroll = function (a) {
        var b = this.getScrollThresholdFirstItem();
//        this.prevUrl = this.getPrevUrl(); /* modified */
        cyclone3.log('ias.history.onScroll() prevUrl = ' + this.prevUrl);
//        this.prevUrl && (a -= this.ias.$scrollContainer.height(), b >= a && this.prev()) /* don't autotrigger */
    }, this.getPrevUrl = function (a) {
		
		cyclone3.log('ias.history.getPrevUrl() searching = ' + $(this.prevSelector, this.ias.$container).last().attr("href"));
		
        return a || (a = this.ias.$container), $(this.prevSelector, a).last().attr("href")
    }, this.getScrollThresholdFirstItem = function () {
        var a;
        return a = this.ias.getFirstItem(), 0 === a.length ? -1 : a.offset().top
    }, this.renderBefore = function (a, b) {
        var c = this.ias,
            d = c.getFirstItem(),
            e = 0;
        c.fire("render", [a]), $(a).hide(), d.before(a), $(a).fadeIn(400, function () {
            ++e < a.length || (c.fire("rendered", [a]), b && b())
        })
    }, this
};

IASHistoryExtension.prototype.initialize = function (a) {
    var b = this;
    this.ias = a, jQuery.extend(a.listeners, this.listeners), a.prev = function () {
        return b.prev()
    }, this.prevUrl = this.getPrevUrl()
}, IASHistoryExtension.prototype.bind = function (a) {
    var b = this;
    cyclone3.log('ias.history.bind() on("pageChange")');
    a.on("pageChange", $.proxy(this.onPageChange, this)), a.on("scroll", $.proxy(this.onScroll, this)), a.on("ready", function () {
        var c = a.getCurrentScrollOffset(a.$scrollContainer),
            d = b.getScrollThresholdFirstItem();
        c -= a.$scrollContainer.height(), d >= c && b.prev()
    })
}, IASHistoryExtension.prototype.prev = function () {
    var a = this.prevUrl,
        b = this,
        c = this.ias;
//    try {
//			cyclone3.log(c);
//			a = c.extensions[2].getPrevUrl();
//	 }catch(e){cyclone3.log('error=' + e)};
    if (!a) return !1;
    if (c.stopprev) return !1;
    c.unbind();
    cyclone3.log('ias.history.prev() fire "prev"');
    var d = c.fire("prev", [a]);
    return d.done(function () {
		 cyclone3.log('ias.history.prev() load()');
        c.load(a, function (a, d) {
            b.renderBefore(d, function () {
                b.prevUrl = b.getPrevUrl(a), c.bind(), b.prevUrl && b.prev()
            })
        })
    }), d.fail(function () {
        c.bind()
    }), !0
}, IASHistoryExtension.prototype.defaults = {
    prev: ".prev"
};

var IASNoneLeftExtension = function (a) {
    return a = $.extend({}, this.defaults, a), this.ias = null, this.uid = (new Date).getTime(), this.html = a.html.replace("{text}", a.text), this.showNoneLeft = function () {
        var a = $(this.html).attr("id", "ias_noneleft_" + this.uid),
            b = this.ias.getLastItem();
        b.after(a), a.fadeIn()
    }, this
};

IASNoneLeftExtension.prototype.bind = function (a) {
	cyclone3.log('ias.noneleft.bind() on("noneLeft")');
    this.ias = a, a.on("noneLeft", $.proxy(this.showNoneLeft, this))
}, IASNoneLeftExtension.prototype.defaults = {
    text: "You reached the end.",
    html: '<div class="ias-noneleft" style="text-align: center;">{text}</div>'
};

var IASPagingExtension = function () {
    return this.ias = null, this.pagebreaks = [
        [0, document.location.toString()]
    ], this.lastPageNum = 1, this.enabled = !0,
    this.listeners = {
        pageChange: new IASCallbacks
    }, this.onScroll = function (a) {
        if (this.enabled) {
				a -= this.ias.$scrollContainer.height();
            var b, c = this.ias,
                d = this.getCurrentPageNum(a),
                e = this.getCurrentPagebreak(a);
            cyclone3.log('ias.paging.onScroll() pos=' + a + ' page=' +  this.lastPageNum + '=>' + d + ' pagebreak=' + e);
//            if (!e)
//            {
//						return
//					}
            this.lastPageNum !== d && (
					b = e[1],
					c.fire("pageChange", [d, a, b])
				),
            this.lastPageNum = d
        }
        else
        {
				cyclone3.log('ias.paging.onScroll() !disabled');
		  }
    }, this.onNext = function (a) {
        var b = this.ias.getCurrentScrollOffset(this.ias.$scrollContainer);
			b -= this.ias.$scrollContainer.height();
			e = this.ias.getLastItem();
			b = e.offset().top;
			cyclone3.log('ias.paging.onNext() pagebreaks.push scroll=' + b + ' loc=' + a);
        this.pagebreaks.push([b, a]);
        var c = this.getCurrentPageNum(b) + 1;
// nie, ma reagovat len na scroll this.ias.fire("pageChange", [c, b, a]),
//        this.lastPageNum = c;
    }, this.onPrev = function (a) {
			cyclone3.log('ias.paging.onPrev()');
        var b = this,
            c = b.ias,
            d = c.getCurrentScrollOffset(c.$scrollContainer),
            e = d - c.$scrollContainer.height(),
            f = c.getFirstItem();
        this.enabled = !1, this.pagebreaks.unshift([0, a]), c.one("rendered", function () {
            for (var d = 1, g = b.pagebreaks.length; g > d; d++) b.pagebreaks[d][0] = b.pagebreaks[d][0] + f.offset().top;
            var h = b.getCurrentPageNum(e) + 1;
            cyclone3.log('ias.paging.onPrev() fire pageChange');
            c.fire("pageChange", [h, e, a]), b.lastPageNum = h, b.enabled = !0
        })
    }, this
};

IASPagingExtension.prototype.initialize = function (a) {
    this.ias = a, jQuery.extend(a.listeners, this.listeners)
}, IASPagingExtension.prototype.bind = function (a) {
		cyclone3.log('ias.paging.bind() on("prev","next")');
    try {
        a.on("prev", $.proxy(this.onPrev, this), this.priority)
    } catch (b) {}
    a.on("next", $.proxy(this.onNext, this), this.priority), a.on("scroll", $.proxy(this.onScroll, this), this.priority)
//}, IASPagingExtension.prototype.bind_ = function (a) {
//		cyclone3.log('ias.paging.bind_()');
//    try {
//        a.on("prev", $.proxy(this.onPrev, this), this.priority)
//    } catch (b) {}
//    a.on("next", $.proxy(this.onNext, this), this.priority), a.on("scroll", $.proxy(this.onScroll, this), this.priority)
}, IASPagingExtension.prototype.getCurrentPageNum = function (a) {
    for (var b = this.pagebreaks.length - 1; b > 0; b--)
        if (a > this.pagebreaks[b][0]) return b + 1;
    return 1
}, IASPagingExtension.prototype.getCurrentPagebreak = function (a) {
    for (var b = this.pagebreaks.length - 1; b >= 0; b--)
        if (a > this.pagebreaks[b][0]) return this.pagebreaks[b];
    return null
}, IASPagingExtension.prototype.priority = 500;

var IASSpinnerExtension = function (a) {
    return a = $.extend({}, this.defaults, a), this.ias = null, this.uid = (new Date).getTime(), this.src = a.src, this.html = a.html.replace("{src}", this.src), this.showSpinner = function () {
        var a = this.getSpinner() || this.createSpinner(),
            b = this.ias.getLastItem();
        b.after(a), a.fadeIn()
    }, this.showSpinnerBefore = function () {
        var a = this.getSpinner() || this.createSpinner(),
            b = this.ias.getFirstItem();
        b.before(a), a.fadeIn()
    }, this.removeSpinner = function () {
        this.hasSpinner() && this.getSpinner().remove()
    }, this.getSpinner = function () {
        var a = $("#ias_spinner_" + this.uid);
        return a.length > 0 ? a : !1
    }, this.hasSpinner = function () {
        var a = $("#ias_spinner_" + this.uid);
        return a.length > 0
    }, this.createSpinner = function () {
        var a = $(this.html).attr("id", "ias_spinner_" + this.uid);
        return a.hide(), a
    }, this
};

IASSpinnerExtension.prototype.bind = function (a) {
	cyclone3.log('ias.spinner.bind() on("next","prev","render")');
    this.ias = a, a.on("next", $.proxy(this.showSpinner, this));
    try {
        a.on("prev", $.proxy(this.showSpinnerBefore, this))
    } catch (b) {}
    a.on("render", $.proxy(this.removeSpinner, this))
}, IASSpinnerExtension.prototype.defaults = {
    src: "data:image/gif;base64,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",
    html: '<div class="ias-spinner" style="text-align: center;"><img src="{src}"/></div>'
};

var IASTriggerExtension = function (a) {
    return a = $.extend({}, this.defaults, a), this.ias = null, this.html = a.html.replace("{text}", a.text), this.enabled = !0, this.count = 0, this.offset = a.offset,
//    this.$triggerNext = null,
    this.$triggerPrev = null,
//    this.showTriggerNext = function () {
//        if (!this.enabled) return !0;
//        if (!1 === this.offset || ++this.count < this.offset) return !0;
//        var a = this.$triggerNext || (this.$triggerNext = this.createTrigger(this.next)),
//            b = this.ias.getLastItem();
//        return b.after(a), a.fadeIn(), !1
//    },
    this.showTriggerPrev = function () {
			this.ias.prevUrl = this.ias.extensions_['history'].getPrevUrl();
		  cyclone3.log('ias.trigger.showTriggerPrev(enabled=' + this.enabled + ' url=' + this.ias.prevUrl + ')');
		  if (this.enabled && !this.ias.prevUrl)
		  {
//				cyclone3.log('ias.trigger reset');
//				cyclone3.log(cyclone3.ias);
//				cyclone3.ias.extensions[3].lastPageNum=1;
//				cyclone3.ias.extensions[3].pagebreaks=[[0,document.location.toString()]];
//				cyclone3.log(cyclone3.ias);
//				this.enabled = !0, this.$triggerPrev && (this.$triggerPrev.remove(), this.$triggerPrev = null);
//				this.$triggerPrev.hide();
//				this.$triggerPrev && this.$triggerPrev.hide();
//				this.$triggerPrev && (this.$triggerPrev.remove(), this.$triggerPrev = null);
//				cyclone3.log('ias.trigger reset end');
				
//				this.ias.stopprev = 1; /* don't allow to load any prev */
				
//				return !0;
		  }
		  if (this.ias.stopprev) return !0;
        if (!this.enabled) return !0;
        var a = this.$triggerPrev || (this.$triggerPrev = this.createTrigger(this.prev)),
            b = this.ias.getFirstItem();
//        cyclone3.log('showTriggerPrev()');
        return b.before(a), a.fadeIn(), !1
    }, this.createTrigger = function (a) {
		 cyclone3.log('ias.trigger.createTrigger()');
        var b = (new Date).getTime(),
            c = $(this.html).attr("id", "ias_trigger_" + b);
        return c.hide(), c.on("click", $.proxy(a, this)), c
    }, this
};

IASTriggerExtension.prototype.bind = function (a) {
    var b = this;
    cyclone3.log('ias.trigger.bind() on("prev","rendered")');
    this.ias = a;
    try {
        a.on("prev", $.proxy(this.showTriggerPrev, this), this.priority)
    } catch (c) {
//		cyclone3.log('can\'t on "prev" ' + c);
    }
//    a.on("next", $.proxy(this.showTriggerNext, this), this.priority),
    a.on("rendered", function () {
//		 if (b.prevUrl){
//			b.showTriggerPrev();
//		};
        b.enabled = !0
    }, this.priority)
}, IASTriggerExtension.prototype.next = function () {
//    this.enabled = !1, this.ias.unbind(), this.$triggerNext && (this.$triggerNext.remove(), this.$triggerNext = null), this.ias.next()
}, IASTriggerExtension.prototype.prev = function () {
		cyclone3.log('ias.trigger.prev(' + this.ias.prevUrl + ')');
//		if (this.ias.prevUrl)
//		{
			this.enabled = !1, this.ias.unbind(), this.$triggerPrev && (this.$triggerPrev.remove(), this.$triggerPrev = null), this.ias.prev()
//		}
//		else
//		{
//			this.ias.unbind(), this.$triggerPrev && (this.$triggerPrev.remove(), this.$triggerPrev = null), this.ias.prev();
//		}
}, IASTriggerExtension.prototype.defaults = {
    text: "Load more items",
    html: '<div class="ias-trigger" style="text-align: center; cursor: pointer;"><a>{text}</a></div>',
    offset: 0
}, IASTriggerExtension.prototype.priority = 1e3;


